/**
 * created by CC 2016-07-19
 */
'use strict';
angular.module('editingCenterSubjectModule', ['mgcrea.ngStrap.button']).controller('EditingCenterSubjectController', [
    '$scope',
    '$compile',
    'beforeonload',
    '$element',
    '$q',
    '$timeout',
    '$state',
    '$filter',
    '$validation',
    '$window',
    'trsHttpService',
    'modalDialog',
    'editingCenterAppService',
    'editingCenterService',
    'jsonArrayToStringService',
    'initAddMetaDataService',
    'storageListenerService',
    'trsspliceString',
    'trsSelectDocumentService',
    'initAppRequiredBtnService',
    'initeditctrBtnsService',
    'appDictionaryBtnService',
    'filterEditctrBtnsService',
    'editIsLock',
    'localStorageService',
    'sensitiveWordCheckService',
    'editcenterRightsService',
    'globleParamsSet',
    'newMediaService',
    'appConst',
    'messagePublishService',
    function (
        $scope,
        $compile,
        beforeonload,
        $element,
        $q,
        $timeout,
        $state,
        $filter,
        $validation,
        $window,
        trsHttpService,
        modalDialog,
        editingCenterAppService,
        editingCenterService,
        jsonArrayToStringService,
        initAddMetaDataService,
        storageListenerService,
        trsspliceString,
        trsSelectDocumentService,
        initAppRequiredBtnService,
        initeditctrBtnsService,
        appDictionaryBtnService,
        filterEditctrBtnsService,
        editIsLock,
        localStorageService,
        sensitiveWordCheckService,
        editcenterRightsService,
        globleParamsSet,
        newMediaService,
        appConst,
        messagePublishService,
    ) {
        initStatus();
        initData();
        editingCenterAppService.addFuture($scope, ['sendmessage']);
        /**
         * [initStatus description]初始化！稿件状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                newsFormError: [],
                switch: 'manuscriptInfo', // 默认选中稿件信息
                openBtn: true,
                isCheckSensitiveWords: false,
                sensitiveWordTit: '敏感词校验',
                position: $state.params.appplatform,
                heimaCheckTit: '错别字校对',
                groupNewsPage: {
                    CURRPAGE: 1,
                    PAGESIZE: 50,
                    ITEMCOUNT: 0,
                    PAGECOUNT: 0,
                },
                isawaitrevise: $state.params.isawaitrevise,
                hasTitleSynced: false, // 标题是否已经同步给列表标题
                timeScreen: '',
                timeShowFlag: '',
                isSearch: false,
            };
            $scope.status.hasVersionTime = !!angular.isDefined($state.params.appchnldocid);
            $scope.data = {
                specialDoc: 0,
                originGroupNews: [], // 存放关联稿件的初始数组
                userName: '',
                copyVersion: [],
                listStyle: editingCenterAppService.initListStyle('addZTPIC'),
                label: '',
                displaySet: editingCenterAppService.initDisplaySet(),
                trench: appConst.params.listenStroageKey,
                groups: [],
                groupNews: [],
                KEYWORDS: [],
                versionTime: [],
                copyDraft: [],
                copyDraftLog: [],
                Channel: [],
                comment: [],
                voiceObj: {},
                path: {
                    '-1': 'editingCenterIwoPersonalVersionTime',
                    '1': 'editingCenterAppPersonalVersionTime',
                    '2': 'editingCenterWebsitePersonalVersionTime',
                    '3': 'editingCenterPaperPersonalVersionTime',
                    '4': 'editingCenterWeixinPersonalVersionTime',
                },
                FOCUSNEWSID: '',
                ASSIGNNEWS: '',
                docGenre: editingCenterAppService.initDocGenre(),
                listPicRatio: {
                    set: {
                        0: '',
                    },
                    practical: {
                        0: '1',
                    },
                },
                focusRatio: {
                    set: '',
                    practical: '1',
                },
                bigPicRtion: {
                    set: '', // 大图只需要设置的值不需要单独实际值，因为大图使用的是列表图的第一张
                },
                specZtPicRtion: {
                    set: '', // 窄图
                },
                hasSelectArr: {}, //非检索出来的全部稿件
                deleteSpecialGroupIds: ''
            };
            $scope.params = {
                serviceid: 'mlf_appmetadata',
                methodname: 'getSpecialDoc',
                ChnlDocId: $state.params.appchnldocid,
            };
            $scope.handleBtnClick = function (funname) {
                eval('$scope.' + funname + '()');
            };
            emitCloseWindow();
            // 初始化标签
            editingCenterAppService.initTag($state.params.appsiteid).then(function (list) {
                $scope.data.label = angular.copy(list);
            });
            $scope.editFlag = {
                media: 'app',
                docType: 'subject',
            };
            $scope.keywords = '';
        }

        /**
         * [exportGrouping 导出分组文档]
         * @return {[type]} [description]
         */
        $scope.exportGrouping = function () {
            var params = {
                serviceid: 'mlf_appmetadata',
                methodname: 'exportGroupingListToExcel',
                specialgroupid: $scope.data.selectedGroup.SPECIALGROUPID,
                docTitle: $scope.list.TITLE,
            };
            var url = trsHttpService.getWCMRootUrl() + '?' + $.param(params);
            window.open(url);
        };

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            window.onbeforeunload = function () {
                localStorageService.set('saveSubjectInnerLog', JSON.stringify({
                    specialGroupIds: $scope.data.deleteSpecialGroupIds ? trsspliceString.spliceString($scope.data.groups, 'SPECIALGROUPID', ',') + ',' + $scope.data.deleteSpecialGroupIds : trsspliceString.spliceString($scope.data.groups, 'SPECIALGROUPID', ','),
                    METADATAID: $scope.list.METADATAID
                }));
                localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $state.params.appmetadataid }));
            };
        }

        /**
         * [getUnsaveSpecialGroupIds description] 获取未保存的分组id
         * @return {[type]} [description]
         */
        function getUnsaveSpecialGroupIds() {
            return trsspliceString.spliceString($scope.data.groups.filter(function (group) {
                return group.METADATAID === "0";
            }), 'SPECIALGROUPID', ',');
        }

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            getCutPictureWidthHeight();
            // 判断是否有修订完成权限
            if ($scope.status.isawaitrevise) {
                editcenterRightsService.initIwoListBtn('iwo.xiuding').then(function (rights) {
                    $scope.status.btnRights = rights;
                });
            }
            (angular.isDefined($state.params.appchnldocid) ? initEditData() : initNewData()).then(function () {
                beforeonload.beforeonloadAlert($scope);
            });
            initBtnArray();
        }

        /**
         * [getCutPictureWidthHeight description]获取图片编辑默认宽高
         * @return {[type]} [description]
         */
        function getCutPictureWidthHeight() {
            var params = {
                serviceid: 'mlf_appconfig',
                methodname: 'getPicsSize',
                objectid: $state.params.appsiteid,
            };
            var pictureSizeArr = [
                'SPECSIZE', // 列表图尺寸
                'SPECBIGSIZE', // 大图尺寸
                'FOCUSIMAGESIZE', // 焦点图尺寸
                'SPECIALSIZE', // 专题题图尺寸
                'SPECZTPICSIZE', // 专题窄图尺寸
            ];
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.status.pictureSize = {};
                pictureSizeArr.forEach(function (value, item) {
                    $scope.status.pictureSize[value] = data[value] = !data[value] ? '100,100' : data[value];
                    var arr = [];
                    if (value === 'SPECSIZE') {
                        arr = data[value].split(',');
                        $scope.data.listPicRatio.set = {
                            0: (arr[0] / arr[1]).toFixed(2),
                            1: (arr[0] / arr[1]).toFixed(2),
                            2: (arr[0] / arr[1]).toFixed(2),
                        };
                    }
                    if (value === 'FOCUSIMAGESIZE') {
                        arr = data[value].split(',');
                        $scope.data.focusRatio.set = (arr[0] / arr[1]).toFixed(2);
                    }
                    if (value === 'SPECBIGSIZE') {
                        arr = data[value].split(',');
                        $scope.data.bigPicRtion.set = (arr[0] / arr[1]).toFixed(2);
                    }
                    if (value === 'SPECZTPICSIZE') {
                        arr = data[value].split(',');
                        $scope.data.specZtPicRtion.set = (arr[0] / arr[1]).toFixed(2);
                    }
                });
            });
        }

        /**
         * [initEditData description]初始化编辑页数据
         * @return {[type]} [description]
         */
        function initEditData() {
            var deffer = $q.defer();
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function (data) {
                $scope.list = data;
                $scope.list.ORIGINAL = '0';
                document.title = data.TITLE;
                $scope.data.FOCUSNEWSID = $scope.list.ISFOCUSNEWS == '1' ? $scope.list.FOCUSNEWSID : '';
                $scope.data.ASSIGNNEWS = $scope.list.DISPLAYSET == '2' ? $scope.list.ASSIGNNEWS : '';
                getPropagandaReview();
                reWriteImg();
                initKeyWords();
                loadDirective();
                syncTitleToListTitle();
                getGroup().then(function (group_data) {
                    if (group_data.length > 0) {
                        $scope.data.selectedGroup = group_data[0];
                        getGroupDraft();
                    }
                });
                getKeyWords();
                deffer.resolve();
            });
            // 稿件加锁
            editIsLock.lockDraft($state.params.appmetadataid);
            return deffer.promise;
        }

        /**
         * [initNewData description]初始化新建页数据
         * @return {[type]} [description]
         */
        function initNewData() {
            var deffer = $q.defer();
            editingCenterAppService.initTag($state.params.appsiteid).then(function (list) {
                $scope.list = initAddMetaDataService.initSubject();
                $scope.list.ORIGINAL = '0';
                $scope.list.LABEL = list.length === 0 ? '' : list[0].value;
                loadDirective();
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [reWriteImg description]回写图片列表数据
         * @return {[type]} [description]
         */
        function reWriteImg() {
            var imgArray = ['FOCUSIMAGE', 'LISTPICS', 'FIGURE', 'FOCUSNEWSIMG'];
            angular.forEach(imgArray, function (data, index) {
                if ($scope.list[data] !== 0) {
                    var arrayDocPic = [];
                    angular.forEach($scope.list[data], function (dataC, indexC) {
                        arrayDocPic.push({
                            APPFILE: dataC.APPFILE,
                            APPDESC: dataC.APPDESC,
                            PERPICURL: dataC.PERPICURL,
                        });
                    });
                    $scope.list[data] = arrayDocPic;
                }
            });
        }

        // 空格增加关键词
        $scope.blank = function (e) {
            if (e.keyCode == 32 && $scope.list.KEYWORDS.indexOf($scope.keywordTxt) < 0) {
                $scope.list.KEYWORDS.push($scope.keywordTxt);
                $scope.keywordTxt = '';
            }
        };

        // 删除关键词
        $scope.delete = function (record) {
            $scope.list.KEYWORDS.splice(record, 1);
        };

        /**
         * [initKeyWords description] 初始化关键词
         * @return  {[type]}  [return description]
         */
        function initKeyWords() {
            if ($scope.list.KEYWORDS !== '') {
                var KEYWORDS = $scope.list.KEYWORDS.split(';');
                $scope.data.KEYWORDS = [];
                angular.forEach(KEYWORDS, function (data, index, array) {
                    $scope.data.KEYWORDS.push({
                        name: data,
                    });
                });
            } else {
                $scope.data.KEYWORDS = [];
            }
        }

        /**
         * [getKeyWords description] 获取关键词
         * @return  {[type]}  [return description]
         */
        function getKeyWords() {
            $scope.list.KEYWORDS = '';
            angular.forEach($scope.data.KEYWORDS, function (data, index, array) {
                if (index != $scope.data.KEYWORDS.length - 1) {
                    $scope.list.KEYWORDS += data.name + ';';
                } else {
                    $scope.list.KEYWORDS += data.name;
                }
            });
        }

        $scope.invalidTag = function (tag) {
            var reg = /^[^<>\/;]*$/;
            if (tag.name.length > 20) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '单个关键词长度不能超过20！';
            }
            if (!reg.test(tag.name)) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '不能包含特殊字符！';
            }
        };
        $scope.checkTag = function (tag) {
            var len = $scope.data.KEYWORDS.length;
            if (len == 10) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '关键词个数不能超过10个！';
                return false;
            } else {
                $scope.keywordsTips = '';
                $scope.isShowKeywordTips = false;
            }
            if (tag.name.indexOf(' ') > -1) {
                var spaceArr = tag.name.split(' ');
                $timeout(function () {
                    $scope.data.KEYWORDS.pop();
                    var containArr = [];
                    for (var j = 0; j < $scope.data.KEYWORDS.length; j++) {
                        containArr.push($scope.data.KEYWORDS[j].name);
                    }
                    for (var i = 0; i < spaceArr.length; i++) {
                        if (containArr.indexOf(spaceArr[i]) < 0 && spaceArr[i] != '') {
                            $scope.data.KEYWORDS.push({ name: spaceArr[i] });
                            containArr.push(spaceArr[i]);
                        }
                    }
                });
            }
        };
        $scope.leave = function () {
            // $scope.isShowKeywordTips = false;
        };
        $scope.enter = function () {
            var reg = /^[^<>\/]*$/;
            if (angular.isDefined($scope.KEYWORDTEXT) && (!reg.test($scope.KEYWORDTEXT) || $scope.KEYWORDTEXT.length > 20)) {
                $scope.isShowKeywordTips = true;
            }

            /* if (angular.isDefined($scope.keywordsTips) && $scope.keywordsTips !== "") {
                $scope.isShowKeywordTips = true;
            }*/
        };

        /**
         * [deleteUploaderImg description]删除上传后的图片
         * @param  {[str]} attribute [description]要删除的属性
         * @param  {[num]} index     [description]下标
         * @return {[type]}           [description]
         */
        $scope.deleteUploaderImg = function (attribute, index) {
            if (attribute === 'LISTPICS') {
                $scope.list[attribute][index] = {
                    APPFILE: '',
                    APPDESC: '',
                    PERPICURL: '',
                };
            } else {
                $scope.list[attribute] = [];
            }
        };

        /**
         * [updateCKSelection description]切换checkbox
         * @param  {[string]} attribute [description]需要切换的属性
         * @return {[type]}           [description]
         */
        $scope.updateCKSelection = function (attribute) {
            // if (attribute === 'ISFOCUSIMAGE' && $state.params.appplatform === '2') {
            //     modalDialog.alertType('', '稿件已签发后，无法勾选或取消勾选栏目焦点图', 'error', false, function() {});
            //     return;
            // }
            $scope.list[attribute] = $scope.list[attribute] == '0' ? '1' : '0';
        };

        /**
         * [save description]保存函数
         * @return {[type]} [description]
         */
        $scope.save = function () {
            // type = angular.isDefined(type) ? type : true;
            save(true).then(function () {
                editIsLock.lockDraft($state.params.appmetadataid);
                messagePublishService.publish('showSubjectOperLog', $scope.list.METADATAID);
            });
        };

        /**
         * [getPropagandaReview description]获取宣传部评审流程
         *
         * @return  {[type]}  [return description]
         */
        function getPropagandaReview() {
            var deffer = $q.defer();
            editingCenterService.getPropagandaReview(1, $state.params.appmetadataid).then(function (data) {
                $scope.data.propagandaReview = data;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [openPersonalVersionTime description] 打开流程版本详情页
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.openPersonalVersionTime = function (item) {
            var path = $scope.data.path[item.MEDIATYPE];
            var params = {
                objectversionid: item.OBJECTVERSIONID,
                chnldocid: $state.params.appchnldocid,
            };
            var url = $state.href(path, params);
            item.url = url;
        };

        /**
         * [dealAttribute description]处理属性
         * @return {[obj]} [description]list对象
         */
        function dealAttribute() {
            getKeyWords();
            // 根据列表样式过滤多余的图片信息
            if ($scope.list.LISTSTYLE == '2') {
                $scope.list.LISTPICS = [];
            } else if ($scope.list.LISTSTYLE == '0') {
                $scope.list.LISTPICS = [].concat(angular.copy($scope.list.LISTPICS[0]));
            }
            // $scope.list.ISFOCUSNEWS = "1";
            if ($scope.list.ISFOCUSNEWS == '0') {
                // 若不选中焦点新闻，则不传id字段
                delete $scope.list.FOCUSNEWSID;
            } else {
                $scope.list.FOCUSNEWSID = $scope.data.FOCUSNEWSID;
            }
            $scope.data.FOCUSNEWSID = $scope.list.ISFOCUSNEWS == '0' ? '' : $scope.data.FOCUSNEWSID;
            $scope.list.FOCUSNEWSIMG = $scope.list.ISFOCUSNEWS == '0' ? [] : $scope.list.FOCUSNEWSIMG;
            if ($scope.list.DISPLAYSET != '2') {
                // 若不选中指定新闻，则不传id字段
                delete $scope.list.ASSIGNNEWS;
            } else {
                $scope.list.ASSIGNNEWS = $scope.data.ASSIGNNEWS;
            }
            $scope.list.CUSTOMTIME = globleParamsSet.filterTime($scope.list.CUSTOMTIME, 'yyyy-MM-dd HH:mm');
            // $scope.list.FIGURE = $scope.list.ISSELECTFIGURE == '0' ? [] : $scope.list.FIGURE;
            var list = angular.copy($scope.list);
            $scope.status.openBtn = false;
            list.CONTRIBUTORSAUTHER = $scope.data.userName;
            list.LISTPICS = angular.copy(jsonArrayToStringService.clearEmptyArray(list.LISTPICS));
            list = jsonArrayToStringService.jsonArrayToString(list);
            list.SERVICEID = 'mlf_appmetadata';
            list.METHODNAME = 'saveSpecialDoc';
            list.SpecialGroupIds = $scope.data.deleteSpecialGroupIds ? trsspliceString.spliceString($scope.data.groups, 'SPECIALGROUPID', ',') + ',' + $scope.data.deleteSpecialGroupIds : trsspliceString.spliceString($scope.data.groups, 'SPECIALGROUPID', ',');
            list.ORIGINALTYPE = $scope.data.originType;
            list.SPECIALDOC = $scope.data.specialDoc;
            return list;
        }

        /**
         * [manageListAfterSave description]保存后处理数据
         * @param  {[obj]} data [description]保存后的返回值
         * @param  {[boolean]} flag [description]标志位
         * @return {[type]}      [description]
         */
        function manageListAfterSave(data, flag) {
            $scope.status.openBtn = true;
            $state.params.appmetadataid = $scope.list.METADATAID = data.METADATAID;
            $state.params.appchnldocid = $scope.list.CHNLDOCID = data.CHNLDOCID;
            if (flag) {
                storageListenerService.addListenerToApp('save');
                $state.transitionTo($state.current, $state.params, {
                    reload: false,
                });
                $timeout(function () {
                    modalDialog.saveModel('保存成功', '', 'success');
                }, 500);
            } else {
                $scope.params = {
                    ChannelId: $state.params.appCHANNELID,
                    ObjectIds: $state.params.appCHNLDOCID,
                    ChnlDocIds: $state.params.appCHNLDOCID,
                    MetaDataIds: $state.params.appMETADATAID,
                    serviceid: 'mlf_appoper',
                };
            }
        }

        /**
         * [save description] 保存方法
         * @param   {[type]}  flag  [flag description]
         * @return  {[type]}        [return description]
         */
        function save(flag) {
            var deferred = $q.defer();
            groupNewsIsEmpty($scope.data.groups, 0).then(function (isEmpty) {
                if (isEmpty) {
                    $timeout(function () {
                        modalDialog.alertType('分组内容不可为空！', '', 'error', 'confirm');
                    }, 100);
                    deferred.reject();
                    return deferred.promise;
                }
                $validation.validate($scope.subjectForm.authorForm);
                $validation
                    .validate($scope.subjectForm)
                    .success(function () {
                        editingCenterAppService
                            .examineImageRatio($scope.list, $scope.data, $scope.status, 'SPECSIZE', 'SPECBIGSIZE', 'SPECZTPICSIZE')
                            .then(function () {
                                modalDialog.isSecretInformation(
                                    $state.params.appmetadataid,
                                    function () {
                                        sensitiveWordCheckService.sensitiveWords($scope).then(
                                            function (sensitiveWords) {
                                                $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                                $scope.list.SENSITIVEWORDS = sensitiveWords;
                                                $scope.subjectForm.$setPristine();
                                                var list = dealAttribute();
                                                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                                    function (data) {
                                                        manageListAfterSave(data, flag);
                                                        beforeonload.refresh($scope);
                                                        saveSort().then(function () {
                                                            deferred.resolve(data);
                                                        }, function () {
                                                            deferred.resolve(data);
                                                        });
                                                    },
                                                    function (data) {
                                                        $scope.status.openBtn = true;
                                                        deferred.reject(data);
                                                    }
                                                );
                                            },
                                            function () {
                                                $scope.status.isCheckSensitiveWords = Math.random();
                                            },
                                        );
                                    },
                                    function () {
                                    },
                                );
                            });
                    })
                    .error(function () {
                        editingCenterService.checkSaveError($scope.subjectForm, $element, $scope); // 定位输入错的表单位置
                    });
            });
            return deferred.promise;
        }

        /**
         * [saveSort description] 保存顺序
         *
         * @return  {[type]}   [return description]
         */
        function saveSort() {
            const defer = $q.defer();
            const params = {
                serviceid: 'mlf_specialgroup',
                methodname: 'orderSpecialGroupNews',
                METADATAID: $scope.list.METADATAID,
                SpecialGroupID: $scope.data.selectedGroup.SPECIALGROUPID,
                OrderBy: $scope.status.timeShowFlag
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function () {
                defer.resolve();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        }

        /**
         * [groupNewsIsEmpty description] 判断分组内容是否为空
         * @param  {[type]} groups [description] 所有分组
         * @param  {[type]} index  [description] 分组序号
         * @return {[type]}        [description]
         */
        function groupNewsIsEmpty(groups, index) {
            var defer = $q.defer();
            if (groups.length === 0) {
                defer.resolve(true);
            } else {
                groupNewsCheck(groups, index, function (isEmpty) {
                    defer.resolve(isEmpty);
                });
            }
            return defer.promise;
        }

        /**
         * [groupNewsCheck description] 校验每个分组是否有内容
         * @param  {[type]}   groups   [description] 所有分组
         * @param  {[type]}   index    [description] 分组序号
         * @param  {Function} callback [description] 回调函数
         * @return {[type]}            [description]
         */
        function groupNewsCheck(groups, index, callback) {
            if (angular.isDefined(groups[index])) {
                var params = {
                    serviceid: 'mlf_specialgroup',
                    methodname: 'querySpecialGroupNewsFromGroup',
                    SpecialGroupID: groups[index].SPECIALGROUPID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    if (!data || data.length === 0) {
                        $scope.selectGroup(groups[index]);
                        callback(true);
                    } else {
                        index++;
                        groupNewsCheck(groups, index, callback);
                    }
                });
            } else {
                callback(false);
            }
        }

        /**
         * [appTrial description]APP送审操作
         * @return {[type]} [description]
         */
        $scope.appTrial = function () {
            trial();
        };

        /**
         * [trial description]稿件送审
         * @return {[type]} [description]
         */
        function trial() {
            newMediaService.trial($scope, appConst.params.trialParams).then((opinion) => {
                save().then(function () {
                    let trialParams = angular.extend({
                        MetaDataIds: $scope.list.METADATAID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        ChannelId: $state.params.appchannelid,
                        Opinion: opinion,
                    }, appConst.params.trialParams);
                    messagePublishService.publish('doEditPageOperation', trialParams);
                });
            });
        }

        /**
         * [appSignDirect description]app直接签发
         * @return {[type]} [description]
         */
        $scope.appSignDirect = function () {
            var isHasPushHeadDraft = hasPushHeadDraft(true);
            if (isHasPushHeadDraft) {
                modalDialog.alertType('推头条稿件不可进行签发！', '', 'error', false);
                return;
            }
            signDirect();
        };

        /**
         * [hasPushHeadDraft description] 判断所选稿件中是否存在推头条稿件
         * @return {Boolean} [description]
         */
        function hasPushHeadDraft() {
            var hasPushHeadDraft = false;
            if ($scope.list.PUSHHEADLINETYPE == '2') {
                hasPushHeadDraft = true;
            }
            return hasPushHeadDraft;
        }

        /**
         * [signDirect description]直接签发
         *
         * @param   {[type]}  isSaveAndPublish  [isSaveAndPublish description]
         *
         * @return  {[type]}                    [return description]
         */
        function signDirect(isSaveAndPublish) {
            var array = [$scope.list];
            if (isSaveAndPublish) {
                signPrivate();
            } else {
                sensitiveWordCheckService.SensitiveWordsAndCareful(array, true, '1').then(
                    function () {
                        signPrivate();
                    },
                    function () {
                        signPrivate();
                    },
                );
            }
        }

        /**
         * [signPrivate description]
         *
         * @return  {[type]}  [return description]
         */
        function signPrivate() {
            var methodname = ['appDaiBianPublish', 'appDaiShenPublish', 'appYiQianFaPublish'];
            $scope.loadingPromise = newMediaService.sign($scope).then(function () {
                save().then(() => {
                    let signParams = {
                        serviceid: 'mlf_appoper',
                        methodname: methodname[$state.params.appplatform],
                        ObjectIds: $scope.list.CHNLDOCID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                    };
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        }

        /**
         * [appSignTiming description]定时签发
         * @return {[type]} [description]
         */
        $scope.appSignTiming = function () {
            var isHasPushHeadDraft = hasPushHeadDraft(true);
            if (isHasPushHeadDraft) {
                modalDialog.alertType('推头条稿件不可进行签发！', '', 'error', false);
                return;
            }
            timeSign();
        };

        /**
         * [timeSign description]定时签发函数
         * @return {[type]} [description]
         */
        function timeSign() {
            var methodname = ['appDaiBianTimingPublish', 'appDaiShenTimingPublish'];
            $scope.loadingPromise = newMediaService.timeSign($scope).then(function () {
                save().then(() => {
                    let signParams = {
                        serviceid: 'mlf_appoper',
                        methodname: methodname[$state.params.appplatform],
                        ObjectIds: $scope.list.CHNLDOCID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                    };
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        }

        /**
         * [appPreview description]稿件预览
         * @return {[type]} [description]
         */
        $scope.appPreview = function () {
            save().then(function (data) {
                editIsLock.lockDraft($state.params.appmetadataid);
                mobilePreview();
            });
        };

        /**
         * [mobilePreview description]手机端预览方法
         * @return {[type]} [description]
         */
        function mobilePreview() {
            $scope.loadingPromise = editingCenterAppService.appPrevewPublish($state.params.appchnldocid).then(
                function () {
                },
                function () {
                    editIsLock.lockDraft($state.params.appmetadataid);
                },
            );
        }

        /**
         * [appRevoke description]稿件撤稿
         * @return {[type]} [description]
         */
        $scope.appRevoke = function () {
            // save().then(function(data) {
            revoke();
            // });
        };

        /**
         * [revoke description]撤稿函数
         * @return {[type]} [description]
         */
        function revoke() {
            newMediaService.rejection($scope, appConst.params.rejectionParams).then((opinion) => {
                save().then(function () {
                    let KillParams = angular.extend({
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                        Opinion: opinion,
                        ChannelId: $state.params.appchannelid,
                    }, appConst.params.rejectionParams);
                    messagePublishService.publish('doEditPageOperation', KillParams);
                });
            });
        }

        /**
         * [appSavePublish description]保存并发布
         * @return {[type]} [description]
         */
        $scope.appSavePublish = function () {
            // save().then(function(data) {
            signDirect(true);
            // });
        };

        /**
         * [revise description] 修订
         * @return {[type]} [description]
         */
        $scope.revise = function () {
            modalDialog.confirmModal('修订', '确认修订?', function () {
                save().then(
                    function () {
                        var params = {
                            serviceid: 'mlf_modifydoc',
                            methodname: 'paperModifyDocsFinished',
                            PaperDocIds: $state.params.appmetadataid,
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                            function (data) {
                                modalDialog.alertType(
                                    '修订成功',
                                    '',
                                    'success',
                                    false,
                                    function () {
                                        storageListenerService.addListenerToNewspaper('xiuding');
                                        $window.close();
                                    },
                                    '',
                                    1500,
                                );
                            },
                            function (data) {
                                editIsLock.lockDraft($state.params.appmetadataid);
                            },
                        );
                    },
                    function () {
                        editIsLock.lockDraft($state.params.appmetadataid);
                    },
                );
            });
        };

        /**
         * [close description]关闭页面
         * @return {[type]} [description]
         */
        $scope.close = function () {
            editingCenterService.closeWinow($scope.subjectForm.$dirty, false).then(
                function () {
                    save().then(function () {
                        deleteUnsavedGroup();
                        storageListenerService.addListenerToApp('save');
                        editIsLock.normalLock($state.params.appmetadataid).then(function (data) {
                            $window.open('about:blank', '_self').close();
                        });
                    });
                },
                function () {
                    angular.isDefined($state.params.appmetadataid)
                        ? editIsLock.normalLock($state.params.appmetadataid).then(function (data) {
                            deleteUnsavedGroup();
                        })
                        : deleteUnsavedGroup();
                },
            );
        };

        /**
         * [deleteUnsavedGroup description] 关闭页面时删除未保存的分组新闻信息
         * @return {[type]} [description]
         */
        function deleteUnsavedGroup() {
            var specialGroupIds = getUnsaveSpecialGroupIds();
            if (specialGroupIds !== '') {
                if ($scope.list.METADATAID == '0') {
                    unrelatedGroupDelect(specialGroupIds).then(function () {
                        var opened = $window.open('about:blank', '_self');
                        opened.close();
                    });
                } else {
                    groupDelect(specialGroupIds).then(function () {
                        var opened = $window.open('about:blank', '_self');
                        opened.close();
                    });
                }
            } else {
                var opened = $window.open('about:blank', '_self');
                opened.close();
            }
        }

        /**
         * [initBtnArray description]初始化功能按钮
         * @return {[type]} [description]
         */
        function initBtnArray() {
            if ($scope.status.isawaitrevise) {
                // 待修订状态的编辑页只有保存按钮和修订按钮，在此处加入保存按钮
                addBtn();
                return;
            }
            // 所需的按钮
            $scope.data.appRequiredBtns = initAppRequiredBtnService.initAppRequiredBtns()[$state.params.appplatform];
            // 根据不同平台调用不同权限方法
            $scope.data.rightsMethod = ['app.daibian', 'app.daishen', 'app.yiqianfa'];
            initeditctrBtnsService.initAppData($state.params.appchannelid, $scope.data.rightsMethod[$state.params.appplatform]).then(function (data) {
                // 字典按钮
                $scope.data.dictionaryBtn = [
                    appDictionaryBtnService.initAppCompBtn(),
                    appDictionaryBtnService.initAppPendBtn(),
                    appDictionaryBtnService.initAppSignBtn(),
                ];
                initeditctrBtnsService.initBtns(data, $scope.data.dictionaryBtn[$state.params.appplatform]).then((btns) => {
                    $scope.status.btnStatus = btns;
                    // 最终得到的按钮
                    $scope.data.arrayBtn = filterEditctrBtnsService.filterBtn($scope.status.btnStatus, $scope.data.appRequiredBtns);
                    addBtn();
                });
            });
        }

        /**
         * [addBtn description]新增保存关闭按钮
         */
        function addBtn() {
            $scope.data.arrayBtn = $scope.data.arrayBtn ? $scope.data.arrayBtn : [];
            var OPERDESC = ['保存', '保存'];
            var OPERFUN = ['save', 'save'];
            angular.forEach($scope.data.arrayBtn, function (data, index) {
                if (data.RIGHTINDEX == '418') {
                    // 专题稿件去除二次审核
                    $scope.data.arrayBtn.splice(index, 1);
                }
            });
            if ($state.params.appplatform < 2) {
                $scope.data.arrayBtn.unshift({
                    RIGHTINDEX: 'save',
                    OPERDESC: OPERDESC[$state.params.appplatform],
                    OPERNAME: '',
                    OPERFUN: OPERFUN[$state.params.appplatform],
                });
            }
            // $scope.data.arrayBtn.push({
            //     RIGHTINDEX: "close",
            //     OPERDESC: "关闭",
            //     OPERNAME: "",
            //     OPERFUN: "close"
            // });
        }

        /**
         * [addGroup description]新增分组
         */
        function addGroup() {
            var params = {
                serviceid: 'mlf_specialgroup',
                methodname: 'addGroupInfoFromData',
                GroupName: $scope.data.groupName,
                MetaDataId: $scope.list.METADATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function () {
                getGroup().then(function() {
                    if (!$scope.data.selectedGroup) {
                        $scope.data.selectedGroup = $scope.data.groups[0];
                    }
                });
            });
        }

        /**
         * 分组新闻相关操作来时
         */
        /**
         * [addGrouping description]添加分组
         * @param {[type]} event [description]
         */
        $scope.newGroup = function (ev) {
            if ($scope.subjectForm.packetNews.$valid !== true) {
                // 表单校验不通过，不允许添加
                return;
            }
            if (angular.isDefined(ev) && ev.keyCode == 13) {
                if ($scope.data.groupName.length > 50 || $scope.data.groupName.length < 1) {
                    modalDialog.alertType('创建分组失败', '分组长度必须在1-50个字符之间！', 'error', 'confirm');
                    return;
                }
                addGroup();
                $scope.data.groupName = '';
            }
        };

        /**
         * [selectGroup description]选择分组
         * @param  {[obj]} group [description]分组信息
         * @return {[type]}       [description]
         */
        $scope.selectGroup = function (group) {
            resetSortFilter();
            $scope.data.selectedGroup = group;
            getGroupDraft(1);
        };

        /**
         * [getGroup description]获取分组信息
         * @return {[type]} [description]
         */
        function getGroup() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_specialgroup',
                methodname: 'querySpecialGroupsFromData',
                MetaDataId: $scope.list.METADATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.data.groups = data.DATA;
                deffer.resolve(data.DATA);
            });
            return deffer.promise;
        }

        /**
         * [groupDelect description]删除分组
         * @return {[type]} [description]
         */
        $scope.groupDelect = function (e, group) {
            e.stopPropagation();
            var specialGroupIds = group.SPECIALGROUPID;
            modalDialog.confirmModal('删除分组', '您确定删除此分组', function () {
                groupDelect(specialGroupIds);
            });
        };

        /**
         * [groupDelect description] 删除分组函数
         * @return {[type]} [description]
         */
        function groupDelect(specialGroupIds) {
            var deferred = $q.defer();
            var params = {
                serviceid: 'mlf_specialgroup',
                methodname: 'deleteSpecialGroupFromData',
                MetaDataId: $scope.list.METADATAID,
                SpecialGroupIds: specialGroupIds,
            };
            var oldIndex = $scope.data.groups.indexOf($scope.data.selectedGroup);
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.data.deleteSpecialGroupIds = !$scope.data.deleteSpecialGroupIds ? specialGroupIds : $scope.data.deleteSpecialGroupIds + ',' + specialGroupIds;
                getGroup().then(function (data) {
                    if (data.length) {
                        if ($scope.data.selectedGroup && specialGroupIds.indexOf($scope.data.selectedGroup.SPECIALGROUPID) !== -1) {
                            $scope.data.groupNews = [];
                            if (oldIndex < data.length) {
                                $scope.data.selectedGroup = $scope.data.groups[oldIndex < 0 ? 0 : oldIndex];
                            } else if (oldIndex === data.length) {
                                $scope.data.selectedGroup = $scope.data.groups[oldIndex - 1];
                            }
                            getGroupDraft(1);
                        }
                    } else {
                        $scope.data.groupNews = [];
                        $scope.data.selectedGroup = undefined;
                    }
                    deferred.resolve();
                });
            });
            return deferred.promise;
        }

        /**
         * [unrelatedGroupDelect description] 删除未关联到专题的分组
         * @param  {[type]} specialGroupIds [description]
         * @return {[type]}                 [description]
         */
        function unrelatedGroupDelect(specialGroupIds) {
            var deferred = $q.defer();
            var params = {
                serviceid: 'mlf_specialgroup',
                methodname: 'deleteUnrelatedSpecialGroups',
                ObjectIds: specialGroupIds,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                deferred.resolve();
            });
            return deferred.promise;
        }

        /**
         * [downRecord description]分组下移
         * @return {[type]} [description]
         */
        $scope.groupMoveRecord = function (e, group, direction, index, trueIndex) {
            e.stopPropagation();
            if (trueIndex) {
                upAndDownMove(direction, 'groups', group, index, trueIndex);
            } else {
                upAndDown(direction, 'groups', group);
            }
            recordGroupOrder();
        };

        /**
         * [newsUpRecord description]相关新闻上移
         * @return {[type]} [description]
         */
        $scope.newsUpRecord = function (news, index, trueIndex) {
            recordNewsOrder(index, 'up').then(function () {
                upAndDown('up', 'groupNews', news);
            });
        };

        /**
         * [newsDocUpRecord description] 分组新闻相关稿件上移
         * @param  {[type]} item [description] 待上移稿件
         * @return {[type]}      [description]
         */
        $scope.newsDocUpRecord = function (item) {
            let defer = $q.defer();
            let params = {
                serviceid: 'mlf_specialgroup',
                methodname: 'upNews',
                SpecialGroupId: $scope.data.selectedGroup.SPECIALGROUPID,
                ObjectId: item.NEWSSPECIALDATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then((data) => {
                sortTip();
                getGroupDraft();
                defer.resolve();
            });
            return defer.promise;
        };

        /**
         * [newsDownRecord description]相关新闻下移
         * @return {[type]} [description]
         */
        $scope.newsDownRecord = function (news, index, trueIndex) {
            recordNewsOrder(index, 'down').then(function () {
                upAndDown('down', 'groupNews', news);
            });
        };

        /**
         * [newsDocDownRecord description] 分组新闻相关稿件下移
         * @param  {[type]} item [description] 待下移的稿件
         * @return {[type]}      [description]
         */
        $scope.newsDocDownRecord = function (item) {
            let defer = $q.defer();
            let params = {
                serviceid: 'mlf_specialgroup',
                methodname: 'downNews',
                SpecialGroupId: $scope.data.selectedGroup.SPECIALGROUPID,
                ObjectId: item.NEWSSPECIALDATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then((data) => {
                sortTip();
                getGroupDraft();
                defer.resolve();
            });
            return defer.promise;
        };

        /**
         * [newsTopRecord description]相关新闻置顶
         * @return {[type]} [description]
         */
        $scope.newsTopRecord = function (news) {
            var params = {
                serviceid: 'mlf_specialgroup',
                methodname: 'putOnTop',
                ObjectId: news.NEWSSPECIALDATAID,
                SpecialGroupId: $scope.data.selectedGroup.SPECIALGROUPID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.status.groupNewsPage.CURRPAGE = 1;
                sortTip();
                getGroupDraft();
            });
        };

        /**
         * [upAndDown description]数组上移下移
         * @param  {[str]} type      [description]上移或者下移
         * @param  {[str]} attribute [description]要改变的数组
         * @param  {[obj]} select    [description]被选中的值
         * @return {[type]}           [description]
         */
        function upAndDown(type, attribute, select) {
            var index = $scope.data[attribute].indexOf(select);
            if (type === 'up') {
                if (index === 0) {
                    return;
                }
                $scope.data[attribute].splice(index, 1);
                $scope.data[attribute].splice(index - 1, 0, select);
            } else if (type === 'down') {
                if (index === $scope.data[attribute].length) {
                    return;
                }
                $scope.data[attribute].splice(index, 1);
                $scope.data[attribute].splice(index + 1, 0, select);
            } else if (type === 'top') {
                if (index === 0) {
                    return;
                }
                $scope.data[attribute].splice(index, 1);
                $scope.data[attribute].splice(0, 0, select);
            }
        }

        /**
         * [upAndDown description]数据滑动上移或者下移
         * @param  {[str]} type      [description]上移或者下移
         * @param  {[str]} attribute [description]要改变的数组
         * @param  {[obj]} select    [description] index 改变前的值  trueIndex 改变后的值
         * @return {[type]}           [description]
         */
        function upAndDownMove(type, attribute, select, index, trueIndex) {
            if (type === 'up') {
                if (index === 0) {
                    return;
                }
                $scope.data[attribute].splice(index, 1);
                $scope.data[attribute].splice(trueIndex, 0, select);
            } else if (type === 'down') {
                if (index === $scope.data[attribute].length) {
                    return;
                }
                $scope.data[attribute].splice(index, 1);
                $scope.data[attribute].splice(trueIndex, 0, select);
            } else if (type === 'top') {
                if (index === 0) {
                    return;
                }
                $scope.data[attribute].splice(index, 1);
                $scope.data[attribute].splice(trueIndex, 0, select);
            }
        }

        /**
         * [sortTip description] 排序提示
         *
         * @return  {[type]}   [return description]
         */
        function sortTip() {
            if ($scope.status.timeScreen) {
                resetSortFilter();
                modalDialog.alertType('移动成功，其他稿件已重置为默认排序', '', 'info', false);
            }
        }

        /**
         * [recordGroupOrder description]记录分组顺序
         * @return {[type]} [description]
         */
        function recordGroupOrder() {
            var deferred = $q.defer();
            var params = {
                serviceid: 'mlf_specialgroup',
                methodname: 'addSpecialGroups',
                MetaDataId: $scope.list.METADATAID,
                SpecialGroupIds: trsspliceString.spliceString($scope.data.groups, 'SPECIALGROUPID', ','),
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                deferred.resolve();
            });
            return deferred.promise;
        }

        /**
         * [recordNewsOrder description]记录新闻顺序
         * @return {[type]} [description]
         */
        function recordNewsOrder(index, direction) {
            var destinationId;
            var deffer = $q.defer();
            if (direction === 'up') {
                destinationId = $scope.data.groupNews[index - 1].NEWSSPECIALDATAID;
            } else {
                destinationId = $scope.data.groupNews[index + 1].NEWSSPECIALDATAID;
            }
            var params = {
                serviceid: 'mlf_specialgroup',
                methodname: 'moveNews',
                ObjectId: $scope.data.groupNews[index].NEWSSPECIALDATAID,
                SpecialGroupId: $scope.data.selectedGroup.SPECIALGROUPID,
                ExchangeId: destinationId,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
         * [initRelNewsArray description] 获取选中的分组新闻下的所有稿件
         * @return {[type]} [description]
         */
        function initRelNewsArray() {
            let defer = $q.defer();
            if ($scope.status.groupNewsPage.PAGECOUNT > 1 || $scope.status.isSearch) {
                let relNewsArray = [];
                let params = {
                    serviceid: 'mlf_specialgroup',
                    methodname: 'querySpecialGroupNewsFromGroup',
                    SpecialGroupID: $scope.data.selectedGroup.SPECIALGROUPID,
                    CurrPage: 1,
                    PageSize: $scope.data.itemTotal,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    relNewsArray = data.DATA || data;
                    relNewsArray = $filter('unique')(relNewsArray, 'NEWSSPECIALDATAID');
                    angular.forEach(relNewsArray, function (data) {
                        data.METADATAID = data.NEWSSPECIALDATAID;
                        data.LISTTITLE = data.DOCTITLE;
                    });
                    defer.resolve(relNewsArray);
                });
            } else {
                defer.resolve(angular.copy($scope.data.groupNews));
            }
            return defer.promise;
        }

        /**
         * [chooseDraftWindow description]稿件选择框
         * @return {[type]} [description]
         */
        $scope.chooseDraftWindow = function () {
            initRelNewsArray().then((array) => {
                trsSelectDocumentService.trsSelectDocument(
                    {
                        siteid: $state.params.appsiteid,
                        relNewsData: array,
                        showMetadaId: true,
                        isApp: true,
                        docType: '3',
                        platform: 7,
                    },
                    function (result) {
                        if (result.length == 0) {
                            return;
                        }
                        var params = {
                            serviceid: 'mlf_specialgroup',
                            methodname: 'addDataFromSpecialGroup',
                            MetaDataIds: trsspliceString.spliceString(result, 'metadataId', ','),
                            SpecialGroupId: $scope.data.selectedGroup.SPECIALGROUPID,
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function () {
                            if ($scope.status.isSearch) {
                                $scope.data.itemTotal += result.length;
                            }
                            getGroupDraft(1);
                        });
                    },
                );
            });
        };

        /**
         * [clearDraft description]清空稿件
         * @return {[type]} [description]
         */
        $scope.clearDraft = function () {
            modalDialog.confirmModal('清空稿件', '是否确定清空当前分组下所有稿件？', function () {
                var params = {
                    serviceid: 'mlf_specialgroup',
                    methodname: 'cleanUpRelateDoc',
                    MetaDataId: $scope.list.METADATAID,
                    SpecialGroupID: $scope.data.selectedGroup.SPECIALGROUPID
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    modalDialog.alertType('', '稿件清空成功', 'success');
                    getGroupDraft(1);
                })
            })
        }

        /**
         * [getGroupDraft description]获取指定分组下的新闻
         *
         * @param  {[type]}  page   [page description]
         *
         * @return  {[type]}   [return description]
         */
        function getGroupDraft(page) {
            page = page || $scope.status.groupNewsPage.CURRPAGE;
            var params = {
                serviceid: 'mlf_specialgroup',
                methodname: 'querySpecialGroupNewsFromGroup',
                SpecialGroupID: $scope.data.selectedGroup.SPECIALGROUPID,
                CurrPage: page,
                PageSize: $scope.status.groupNewsPage.PAGESIZE,
                searchWord: $scope.keywords,
                OrderBy: $scope.status.timeShowFlag
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.data.groupNews = data.DATA ? data.DATA : data;
                $scope.data.groupNews = $filter('unique')($scope.data.groupNews, 'NEWSSPECIALDATAID');
                angular.forEach($scope.data.groupNews, function (data) {
                    data.METADATAID = data.NEWSSPECIALDATAID;
                    data.LISTTITLE = data.DOCTITLE;
                });
                if (!$scope.status.isSearch) {
                    $scope.data.itemTotal = data.PAGER.ITEMCOUNT; // 保存总数据
                }
                $scope.status.groupNewsPage = data.PAGER;
                $scope.data.hasSelectArr[$scope.data.selectedGroup.SPECIALGROUPID] = $scope.data.groupNews;
            });
        }

        /**
         * [newsDetete description]删除指定分组下的新闻
         * @return {[type]} [description]
         */
        $scope.newsDelete = function (news) {
            modalDialog.alertType('是否在分组中移除该稿件？', '', 'ask', true, () => {
                let params = {
                    serviceid: 'mlf_specialgroup',
                    methodname: 'deleteNewsFromSpecialGroup',
                    SpecialGroupId: $scope.data.selectedGroup.SPECIALGROUPID,
                    MetaDataIds: news.NEWSSPECIALDATAID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    getGroupDraft();
                });
            });
        };

        /**
         * [modifyTagName description]更改标签名
         * @params item [obj] 所选的稿件
         */
        $scope.modifyTagName = function (e, item) {
            e.stopPropagation();
            var originalName = item.SPECIALGROUPNAME;
            editingCenterService.modifyName(item.SPECIALGROUPNAME, function (result) {
                if (result == originalName) {
                    return;
                }
                var params = {
                    serviceid: 'mlf_specialgroup',
                    methodname: 'editSpecialGroupName',
                    ObjectId: item.SPECIALGROUPID,
                    MetaDataId: $state.params.appmetadataid || '0',
                    GroupName: result,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function () {
                    getGroup();
                });
            });
        };

        /**
         * [loadDirective description] 加载指令
         * @return {[type]} [description]
         */
        function loadDirective() {
            editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
            var draftList =
                '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="newsForm"></editor-dir>' +
                '<editor-auth-dir author="list.FGD_AUTHINFO"></editor-auth-dir>';
            draftList = $compile(draftList)($scope);
            $element.find('editor').append(draftList);
        }

        /**
         * [pageChanged description]跳转到下一页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function () {
            getGroupDraft();
        };

        /**
         * [jumpToPage description]跳转到指定页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function () {
            if ($scope.status.groupNewsPage.CURRPAGE > $scope.status.groupNewsPage.PAGECOUNT) {
                $scope.status.groupNewsPage.CURRPAGE = $scope.status.groupNewsPage.PAGECOUNT;
            }
            getGroupDraft();
        };

        /**
         * [selectPageNum description]选择分页条数
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function () {
            getGroupDraft();
        };

        /**
         * [syncTitleToListTitle 将文章标题同步给列表标题]
         *
         * @return  {[type]}  [return description]
         */
        $scope.syncTitleToListTitle = function () {
            syncTitleToListTitle();
        };

        /**
         * [syncTitleToListTitle 将文章标题同步给列表标题实现]
         *
         * @return  {[type]}  [return description]
         */
        function syncTitleToListTitle() {
            if ($scope.status.hasTitleSynced) {
                return;
            } else {
                if ($scope.list.LISTTITLE !== '') {
                    return;
                } else {
                    $scope.list.LISTTITLE = $scope.list.TITLE;
                    $scope.status.hasTitleSynced = true;
                }
            }
        }

        $scope.queryByTime = function () {
            if ($scope.status.isSearch) {
                return;
            }
            if ($scope.status.timeScreen === '') {
                $scope.status.timeScreen = 'desc'; // 表示 降序
                $scope.status.timeShowFlag = 'DOCFIRSTPUBTIME DESC';
            } else if ($scope.status.timeScreen === 'desc') {
                $scope.status.timeScreen = 'asc'; // 表示升序
                $scope.status.timeShowFlag = 'DOCFIRSTPUBTIME ASC';
            } else {
                resetSortFilter();
            }
            getGroupDraft(1);
        };

        /**
         * [resetSortFilter description] 排序字段重置
         *
         * @return  {[type]}   [return description]
         */
        function resetSortFilter() {
            $scope.status.timeScreen = ''; // 默认顺序
            $scope.status.timeShowFlag = '';
        }

        /**
         * [fullTextSearch description]检索
         *
         * @param   {[type]}  ev  [ev description]按下回车也能提交
         *
         * @return  {[type]}      [return description]
         */
        $scope.fullTextSearch = function (ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                if (!$scope.data.selectedGroup) {
                    modalDialog.alertType('检索失败，请首先选择一个分组', '', 'warning', false);
                    return;
                }
                $scope.data.groupNews = [];
                $scope.status.groupNewsPage.CURRPAGE = 1;
                if ($scope.keywords.trim() === '') {
                    $scope.status.isSearch = false;
                } else {
                    $scope.status.isSearch = true;
                }
                getGroupDraft(1);
            }
        };
    },
]);
